import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { P24MerchantTaxIdentification, getP24MerchantTaxIdentificationByName } from "../../constants/P24MerchantTaxIdentification";
import { isValidPesel, isValidNip, isValidDigitCount } from "../../helpers/utils"

//regex dla peselu/id merchanta
const digitsRegExp = new RegExp('^[0-9]+$')
//regex dla nipu
const nipRegExp = new RegExp('^[0-9-]+$')

/**
 * Komponent z wiadomością walidacyjną
 */
const ValidationMessage = ({ isValid, message }) => {
    if (!isValid) {
        return (
            <div className="w3-text-red">{message}</div>
        )
    }
    return null;
}

/**
 * Formularz wyszukiwanie merchanta
 */
class P24MerchantExistsForm extends React.Component {

    state = {
        //zawartość pol pesel i nip
        taxIdentificationNumber: {
            nip: '',
            pesel: ''
        },
        //wybór nip czy pesel
        selectedTaxIdentificationNumber: P24MerchantTaxIdentification.PESEL.name,
        //błędy poszczególnych poł na formularzu
        formErrors: { nip: '', pesel: '' },
        //czy caly form jest zwalidowany poprawnie
        formValid: false,
        //czy nip jest zwalidowany poprawnie
        nipValid: false,
        //czy pesel jest zwalidowany poprawnie
        peselValid: false,
        //czy p24MerchantId jest zwalidowany poprawnie
        p24MerchantIdValid: false,
    }

    /**
     * Walidacja calego formularza
     */
    validateForm = () => {

        const { nipValid, peselValid, p24MerchantIdValid, selectedTaxIdentificationNumber } = this.state;

        //tylko pesel wazny
        if (selectedTaxIdentificationNumber === P24MerchantTaxIdentification.PESEL.name) {
            this.setState({
                formValid: peselValid
            })
        }

        //tylko nip wazny
        if (selectedTaxIdentificationNumber === P24MerchantTaxIdentification.NIP.name) {
            this.setState({
                formValid: nipValid
            })
        }

        //tylko p24MerchantId wazny
        if (selectedTaxIdentificationNumber === P24MerchantTaxIdentification.P24_MERCHANT_ID.name) {
            this.setState({
                formValid: p24MerchantIdValid
            })
        }

    }

    /**
     * Walidacja pola
     */
    validateField = (fieldName, value) => {

        let fieldValidationErrors = this.state.formErrors;
        let nipValid = this.state.nipValid;
        let peselValid = this.state.peselValid;
        let p24MerchantIdValid = this.state.p24MerchantIdValid;

        switch (fieldName) {
            case 'nip':
                //walidacja pod kątem ilości cyfr
                nipValid = isValidDigitCount(value, 10);
                fieldValidationErrors.nip = nipValid ? '' : 'Nip powinien mieć 10 cyfr';

                if (nipValid) {
                    //walidacja pod kątem formatu
                    nipValid = isValidNip(value)
                    fieldValidationErrors.nip = nipValid ? '' : 'Nip jest niepoprawny';
                }

                break;
            case 'pesel':
                //walidacja pod kątem ilości cyfr
                peselValid = isValidDigitCount(value, 11);
                fieldValidationErrors.pesel = peselValid ? '' : 'Pesel powinien mieć 11 cyfr';

                if (peselValid) {
                    //walidacja pod kątem formatu
                    peselValid = isValidPesel(value)
                    fieldValidationErrors.pesel = peselValid ? '' : 'Pesel jest niepoprawny';
                }

                break;
            case 'p24MerchantId':
                //walidacja pod kątem ilości cyfr
                p24MerchantIdValid = value.length > 0;

                break;
            default:
                break;
        }

        this.setState({
            formErrors: fieldValidationErrors,
            peselValid: peselValid,
            nipValid: nipValid,
            p24MerchantIdValid: p24MerchantIdValid
        }, this.validateForm)
    }

    handleSubmit = e => {
        e.preventDefault();
        const p24MerchantTaxIdentificationNumber = getP24MerchantTaxIdentificationByName(this.state.selectedTaxIdentificationNumber);
        this.props.onSubmit(p24MerchantTaxIdentificationNumber, this.state.taxIdentificationNumber);
    };

    handleCancel = e => {
        this.props.onCancel();
    };

    /**
     * Obsluga zmian inputow na formatce, z uwzglednieniem dopuszczalnych wartosci dla poszczgolnych pol
     */
    handleInputChange = e => {

        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        switch (name) {
            case 'nip':
                //dopuszczamy tylko pusty string, cyfry lub minusy
                if (value === '' || nipRegExp.test(value)) {
                    let taxIdentificationNumber = { ...this.state.taxIdentificationNumber, [name]: value };
                    this.setState({ taxIdentificationNumber }, () => { this.validateField(name, value) });
                }
                break;
            case 'pesel':
                //dopuszczamy tylko pusty string, cyfry
                if (value === '' || digitsRegExp.test(value)) {
                    let taxIdentificationNumber = { ...this.state.taxIdentificationNumber, [name]: value };
                    this.setState({ taxIdentificationNumber }, () => { this.validateField(name, value) });
                }
                break;
            case 'p24MerchantId':
                //dopuszczamy tylko pusty string, cyfry
                if (value === '' || digitsRegExp.test(value)) {
                    let taxIdentificationNumber = { ...this.state.taxIdentificationNumber, [name]: value };
                    this.setState({ taxIdentificationNumber }, () => { this.validateField(name, value) });
                }
                break;
            default:
                break;
        }

    };

    /**
     * Obsluga zmiany pola radio nip/pesel/p24MerchantId
     */
    handleOptionChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;

        this.setState({ selectedTaxIdentificationNumber: value }, this.validateForm);
    };

    render() {
        return (
            <div className="w3-card-4">
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">{this.props.title}</h2>
                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s3">
                        <input
                            className="w3-radio"
                            type="radio"

                            onChange={this.handleOptionChange}
                            value={P24MerchantTaxIdentification.PESEL.name}
                            checked={this.state.selectedTaxIdentificationNumber === P24MerchantTaxIdentification.PESEL.name}
                        />
                        <label className="w3-text-theme w3-small">
                            {P24MerchantTaxIdentification.PESEL.displayText} (wymaga podania Pesel)
                        </label>
                    </div>
                    <div className="w3-col s3">
                        <input
                            className="w3-radio"
                            type="radio"

                            onChange={this.handleOptionChange}
                            value={P24MerchantTaxIdentification.NIP.name}
                            checked={this.state.selectedTaxIdentificationNumber === P24MerchantTaxIdentification.NIP.name}
                        />
                        <label className="w3-text-theme w3-small">
                            {P24MerchantTaxIdentification.NIP.displayText} (wymaga podania NIP)
                        </label>
                    </div>
                    <div className="w3-col s3">
                        <input
                            className="w3-radio"
                            type="radio"

                            onChange={this.handleOptionChange}
                            value={P24MerchantTaxIdentification.P24_MERCHANT_ID.name}
                            checked={this.state.selectedTaxIdentificationNumber === P24MerchantTaxIdentification.P24_MERCHANT_ID.name}
                        />
                        <label className="w3-text-theme w3-small">
                            {P24MerchantTaxIdentification.P24_MERCHANT_ID.displayText}
                        </label>
                    </div>
                </div>

                {getP24MerchantTaxIdentificationByName(this.state.selectedTaxIdentificationNumber).isNipRequired && <div className="w3-row-padding">
                    <div className="w3-col s2">
                        <input
                            className="w3-input"
                            type="text"
                            name="nip"
                            onChange={(event) => this.handleInputChange(event)}
                            value={this.state.taxIdentificationNumber.nip}
                        ></input>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Merchant.nip"
                                defaultMessage="Nip"
                            />
                            <ValidationMessage isValid={this.state.nipValid} message={this.state.formErrors.nip} />
                        </label>
                    </div>

                </div>}

                {getP24MerchantTaxIdentificationByName(this.state.selectedTaxIdentificationNumber).isPeselRequired && <div className="w3-row-padding">
                    <div className="w3-col s2">
                        <input
                            className="w3-input"
                            type="text"
                            name="pesel"
                            onChange={(event) => this.handleInputChange(event)}
                            value={this.state.taxIdentificationNumber.pesel}
                            maxLength="11"
                        />
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Merchant.pesel"
                                defaultMessage="Pesel"
                            />
                            <ValidationMessage isValid={this.state.peselValid} message={this.state.formErrors.pesel} />
                        </label>
                    </div>

                </div>}

                {getP24MerchantTaxIdentificationByName(this.state.selectedTaxIdentificationNumber).isP24MerchantIdRequired && <div className="w3-row-padding">
                    <div className="w3-col s2">
                        <input
                            className="w3-input"
                            type="text"
                            name="p24MerchantId"
                            onChange={(event) => this.handleInputChange(event)}
                            value={this.state.taxIdentificationNumber.p24MerchantId}
                            maxLength="11"
                        />
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Merchant.p24MerchantId"
                                defaultMessage="p24MerchantId"
                            />
                            <ValidationMessage isValid={this.state.p24MerchantIdValid} message={this.state.formErrors.p24MerchantId} />
                        </label>
                    </div>

                </div>}

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                            disabled={!this.state.formValid}
                        >
                            {this.props.sumbitText}
                        </button>
                        <button
                            className="w3-btn w3-theme-light w3-bar-item w3-right w3-margin-right"
                            type="reset"
                            onClick={this.handleCancel}
                        >
                            {this.props.cancelText}
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}

P24MerchantExistsForm.defaultProps = {
    merchant: {
        pesel: '',
        nip: ''
    },
    cancelText: 'Anuluj',
    sumbitText: 'Wyszukaj'
}

P24MerchantExistsForm.propTypes = {
    //tytul formularza
    title: PropTypes.string.isRequired,
    //dane wejsciowe obiektu do wypelnienia
    merchant: PropTypes.object.isRequired,
    //akcja zwrotna na anuluj
    onCancel: PropTypes.func.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired,
    //tekst na akcji anuluj
    cancelText: PropTypes.string.isRequired,
    //tekst na akcji zapisz
    sumbitText: PropTypes.string.isRequired
}

export default P24MerchantExistsForm